import script from "./AddNewGeneralContractors.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewGeneralContractors.vue?vue&type=script&setup=true&lang=js"

import "./AddNewGeneralContractors.vue?vue&type=style&index=0&id=1d36bfea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d36bfea"]])

export default __exports__